import React from "react";
import { useKeenSlider } from "keen-slider/react";
import "keen-slider/keen-slider.min.css";
import "./TopBar.css";

const insuranceLogos = [
  { name: "Daman", logo: "https://unidocnetwork.com/i8.svg" },
  { name: "AXA", logo: "https://unidocnetwork.com/i7.svg" },
  { name: "NGI", logo: "https://unidocnetwork.com/i9.svg" },
  { name: "Aetna", logo: "https://unidocnetwork.com/i1.svg" },
  { name: "RSA", logo: "https://unidocnetwork.com/i2.svg" },
  { name: "Almadallah", logo: "https://unidocnetwork.com/i3.svg" },
  { name: "MetLife", logo: "https://unidocnetwork.com/i4.svg" },
  { name: "Nextcare", logo: "https://unidocnetwork.com/i5.svg" },
  { name: "Cigna", logo: "https://unidocnetwork.com/i6.svg" },
  { name: "Oman", logo: "https://unidocnetwork.com/i7.svg" },
];

const chunkArray = (arr, size) =>
  Array.from({ length: Math.ceil(arr.length / size) }, (_, i) =>
    arr.slice(i * size, i * size + size)
  );

const AcceptedInsurance = () => {
  const [sliderRef] = useKeenSlider({
    loop: true,
    slides: {
      origin: "center",
      perView: 1,
    },
    breakpoints: {
      "(min-width: 500px)": {
        slides: { perView: 1 },
      },
    },
    created(s) {
      setInterval(() => s.next(), 3000);
    },
  });

  const logoChunks = chunkArray(insuranceLogos, 6); // 6 logos per slide

  return (
    <div className="accepted-container">
      {/* LEFT TEXT */}
      <div className="accepted-text">
        <h2>Accepted insurances here</h2>
        <p>
          Book an appointment with your nearest accessible care providers,
          accepting your insurance
        </p>
        <ul>
          <li>
            Nearly <strong>100+</strong> Verified Insurances accepted
          </li>
          <li>
            With the largest panel of{" "}
            <strong>health insurance providers</strong>, we’ll find you more
            options for your cover than anyone else.
          </li>
          <li>
            Aligning your search of accessible care provider to your insurance
            provider
          </li>
        </ul>
      </div>

      {/* RIGHT SLIDER */}
      <div ref={sliderRef} className="keen-slider accepted-slider">
        {logoChunks.map((chunk, idx) => (
          <div className="keen-slider__slide accepted-slide" key={idx}>
            {chunk.map((brand, i) => (
              <img key={i} src={brand.logo} alt={brand.name} />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default AcceptedInsurance;
